define(function () {
  return {};
});
